module.exports = __webpack_public_path__ + "img/mail-collaborators.178a205a.svg";